module.exports = __webpack_public_path__ + "static/lepes3-846af907883daaa0c6e4fa9de966fcab.png";